<template>
  <div class="create-analyzer-sources">
    <div class="header">
      <h2>Building Model</h2>
    </div>

    <div class="options">
      <loader></loader>
    </div>
  </div>
</template>

<script>
import config from '../../config';
import Loader from '../Loader.vue';


export default {
  name: 'AnalyzerSources',
  components: { Loader },
  props: {
    analyzer: Object
  },
  data () {
    return {

    }
  },
  methods: {
    createModel() {
      const token = localStorage.getItem('token');

      const body = {
        name: this.analyzer.name,
        analyzer_type: this.analyzer.analyzerType,
        data_sources: {
          documents: this.analyzer.dataSources.documents.map(document => ({
            id: document.id,
            name: document.name,
            content: document.content,
            type: document.type,
            tokens_amount: document.tokens,
          })),
          websites: this.analyzer.dataSources.websites.map(website => ({
            id: website.id,
            visited_links: website.visitedLinks,
            tokens_amount: website.tokens,
            url: website.url,
            follow_external: website.followExternal,
            follow_internal: website.followInternal
          })),
          plain_text: this.analyzer.dataSources.plainText,
        }
      }
      
      fetch(config.api + '/models', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(body)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then(data => {
        const { id } = data;

        this.$router.push(`/models/${id}`);
      })
      .catch(error => {
        if (error.message === '403') {
            this.$router.push('/login');
            return;
        }
        
        console.error('An error occurred while creating model:');
        console.error(error);
        console.error('Model data:', this.analyzer);
        this.$router.push('/models/create/models_type')
      });
    }
  },
  computed: {

  },
  created () {
    this.createModel();
  }
}
</script>

<style scoped>

input {
  width: 90%;
  padding: 2px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/CreateModelFlow/AnalyzerBuild.vue